import React, { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import ProfileLayout from './common/components/layouts/ProfileLayout/ProfileLayout';

const HomePage = lazy(() => import('./common/pages/HomePage/HomePage'));
const Onboarding = lazy(() => import('./common/pages/Onboarding/Onboarding'));
const Course = lazy(() => import('./common/pages/Courses/Courses'));
const TaskContainer = lazy(
  () => import('./common/pages/Courses/TaskContainer/TaskContainer'),
);
const TopicContainer = lazy(
  () => import('./common/pages/Courses/TopicContainer/TopicContainer'),
);
const ForgotPassword = lazy(
  () => import('./common/pages/ForgotPassword/ForgotPassword'),
);
const ResetPassword = lazy(
  () => import('./common/pages/ResetPassword/ResetPassword'),
);
const CreatePassword = lazy(
  () => import('./common/pages/CreatePassword/CreatePassword'),
);
const SentEmailSuccess = lazy(
  () => import('./common/pages/SentEmailSuccess/SentEmailSuccess'),
);
const SignIn = lazy(() => import('./common/pages/SignIn/SignIn'));
const SignUp = lazy(() => import('./common/pages/SingUp/SignUp'));
const AccountInfo = lazy(
  () => import('./common/pages/AccountInfo/AccountInfo'),
);
const ChangePassword = lazy(
  () => import('./common/pages/ChangePassword/ChangePassword'),
);
const ContactUs = lazy(() => import('./common/pages/StaticPages/ContactUs'));
const PaymentDetails = lazy(
  () => import('./common/pages/PaymentDetails/PaymentDetails'),
);
const ProfilePage = lazy(() => import('./common/pages/Profile/ProfilePage'));
const Reminders = lazy(() => import('./common/pages/Reminders/Reminders'));
const Library = lazy(() => import('./common/pages/Library/Library'));
const TermsAndConditions = lazy(
  () => import('./common/pages/StaticPages/TermsAndConditions'),
);
const PrivacyPolicy = lazy(
  () => import('./common/pages/StaticPages/PrivacyPolicy'),
);
const SubscriptionTerms = lazy(
  () => import('./common/pages/StaticPages/SubscriptionTerms'),
);
const SessionRules = lazy(
  () => import('./common/pages/StaticPages/SessionRules'),
);
import { PAGES, PROFILE_PAGES } from './common/types/types';
import { STATIC_PAGES_PATHS } from '../funnels/common/routes/types';
import { AuthenticatedLayout } from './common/components/routingElements/AuthenticatedLayout/AuthenticatedLayout';
import { Providers } from './common/components/layouts/Providers';
import FullscreenLoader from './common/components/elements/FullscreenLoader/FullscreenLoader';

const App: React.FC = () => {
  return (
    <Providers>
      <Suspense fallback={<FullscreenLoader />}>
        <Routes>
          <Route path={`/${PAGES.SIGN_UP}`} element={<SignUp />} />
          <Route path={`/${PAGES.SIGN_IN}`} element={<SignIn />} />
          <Route path={`/${PAGES.FORGOT_PAS}`} element={<ForgotPassword />} />
          <Route path={`/${PAGES.RESET_PAS}`} element={<ResetPassword />} />
          <Route
            path={`/${PAGES.CREATE_PASSWORD}`}
            element={<CreatePassword />}
          />

          <Route element={<AuthenticatedLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path={`/${PAGES.ONBOARDING}`} element={<Onboarding />} />

            <Route path={`/${PAGES.COURSES}/:courseId`} element={<Course />}>
              <Route
                path={`/${PAGES.COURSES}/:courseId/topics/:topicId`}
                element={<TopicContainer />}
              >
                <Route
                  path={`/${PAGES.COURSES}/:courseId/topics/:topicId/tasks/:taskId`}
                  element={<TaskContainer />}
                ></Route>
              </Route>
            </Route>
            <Route path={`/${PAGES.PROFILE}`} element={<ProfileLayout />}>
              <Route path={`/${PAGES.PROFILE}`} element={<ProfilePage />} />
              <Route
                path={`/${PAGES.PROFILE}/${PROFILE_PAGES.ACCOUNT}`}
                element={<AccountInfo />}
              />
              <Route
                path={`/${PAGES.PROFILE}/${PROFILE_PAGES.CONTACT}`}
                element={<ContactUs />}
              />
              <Route
                path={`/${PAGES.PROFILE}/${PROFILE_PAGES.CHANGE_PASS}`}
                element={<ChangePassword />}
              />
              <Route
                path={`/${PAGES.PROFILE}/${PROFILE_PAGES.PAYMENT_DETAILS}`}
                element={<PaymentDetails />}
              />
              <Route
                path={`/${PAGES.PROFILE}/${PROFILE_PAGES.REMINDERS}`}
                element={<Reminders />}
              />
            </Route>
          </Route>

          <Route
            path={`/${PAGES.SENT_EM_SUCCESS}`}
            element={<SentEmailSuccess />}
          />
          <Route path={`/${PAGES.LIBRARY}`} element={<Library />} />
          <Route
            path={`/${STATIC_PAGES_PATHS.TERMS_AND_CONDITIONS}`}
            element={<TermsAndConditions />}
          />
          <Route
            path={`/${STATIC_PAGES_PATHS.PRIVACY_POLICY}`}
            element={<PrivacyPolicy />}
          />
          <Route
            path={`/${STATIC_PAGES_PATHS.SUPPORT}`}
            element={<ContactUs />}
          />
          <Route
            path={`/${STATIC_PAGES_PATHS.SUBSCRIPTION_TERMS}`}
            element={<SubscriptionTerms />}
          />
          <Route
            path={`/${STATIC_PAGES_PATHS.SESSION_RULES}`}
            element={<SessionRules />}
          />
        </Routes>
      </Suspense>
    </Providers>
  );
};

export default App;
